<div *ngFor="let group of images" class="image-group">
  <label>{{ group.label | titlecase }}</label>

  <div class="image-row">
    <div class="image-container" *ngFor="let url of group.value">
      <p-image [src]="url" [preview]="true" [alt]="group.label"></p-image>
    </div>
  </div>
</div>
